import React, { FC } from 'react';
import { MemoryItem, MemoryFact } from '@dreamai/types';
import { ReactComponent as TrashIcon } from '../../icons/trash-outline.svg';

// Approve icon (green checkmark bookmark)
const ApproveIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      d='M7.5 8.75L9.16666 10.4167L12.9167 6.66667M15.8333 17.5V6.5C15.8333 5.09987 15.8333 4.3998 15.5608 3.86502C15.3212 3.39462 14.9387 3.01217 14.4683 2.77248C13.9335 2.5 13.2335 2.5 11.8333 2.5H8.16666C6.76653 2.5 6.06647 2.5 5.53169 2.77248C5.06128 3.01217 4.67883 3.39462 4.43915 3.86502C4.16666 4.3998 4.16666 5.09987 4.16666 6.5V17.5L10 14.1667L15.8333 17.5Z'
      stroke='currentColor'
      strokeWidth='1.75'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

interface MemoryCardProps {
  item: MemoryItem;
  onApprove: (item: MemoryItem) => void;
  onDelete: (item: MemoryItem) => void;
}

const MemoryCard: FC<MemoryCardProps> = ({ item, onApprove, onDelete }) => {
  // Get context from raw data if it's a fact
  const context =
    item.type === 'fact' ? (item.raw as MemoryFact).contextDetails : null;

  return (
    <div className='memory-card'>
      <div className='memory-card-main'>
        <div className='memory-card-header'>
          <div className='memory-card-tags'>
            {item.tags.map((tag, index) => (
              <span key={index} className='memory-card-tag'>
                {tag}
              </span>
            ))}
          </div>
        </div>

        <div className='memory-card-content'>
          <p className='memory-card-text'>{item.displayText}</p>
          {context && <p className='memory-card-context'>{context}</p>}
        </div>
      </div>

      <div className='memory-card-actions'>
        <div className='memory-card-actions-primary'>
          {!item.approved && (
            <button
              className='memory-card-btn primary'
              onClick={() => onApprove(item)}
            >
              <ApproveIcon />
              Yes, that's right
            </button>
          )}
        </div>
        <button
          className='memory-card-btn tertiary'
          onClick={() => onDelete(item)}
        >
          Delete memory
          <TrashIcon />
        </button>
      </div>
    </div>
  );
};

export default MemoryCard;
